export default __webpack_public_path__ + "static/media/Cyclope-1-Red-24x24.86348a21.svg";